export default [
  ["à", "á", "â", "è", "é", "ê", "ë", "î", "ï", "ô"],
  ["ù", "û", "ü", "ÿ", "ç", "-", "'"],
]
